<template>
  <div class="toolbar flex align-center justify-space-between">
    <div class="box-left box grow flex align-center">
      <button
        @click="toggleSidebar"
        v-if="menuBurger !== 'right'"
        class="toggle-sidebar card-base card-shadow--small"
      >
        <v-svg sprite="menu" />
      </button>
      <DadsFilterSelect
        v-if="dropdownVisible && userIsAdmin"
        class="toolbar-select"
        value-key="id"
        placeholder=""
        remote
        filterable
        :value="selectedTenant"
        :loading="tenantsLoading"
        :remote-method="remoteSearchTenants"
        @change="onChangeTenant"
      >
        <el-option
          v-for="item in tenantsList"
          :key="item.id"
          :label="item.tenantCode ? item.name + ' - ' + item.tenantCode.toUpperCase() : item.name"
          :value="item"
        >
        </el-option>
      </DadsFilterSelect>
      <el-form class="form-modal">
        <DadsFilterSelect
          class="toolbar-select"
          :value="selectedQueue"
          value-key="id"
          @change="changeQueue"
          filterable
          v-if="queueMode"
          :style="
            servicesQueue(selectedQueue.id) ? 'color: red; !important' : ''
          "
        >
          <el-option
            v-for="item in queueList"
            :key="item.id"
            :value="item"
            :label="item.name"
          >
            <div class="queue-option" v-if="servicesQueue(item.id)">
              <span>{{ item.name }}</span>
              <v-svg sprite="receptionist" class="voxo-purple"></v-svg>
            </div>
            <div v-else>
              {{ item.name }}
            </div>
          </el-option>
        </DadsFilterSelect>
        <DadsFilterSelect
          filterable
          v-if="operatorMode && userIsAdmin"
          :value="selectedOperatorBranch"
          @change="setActiveOperatorBranch"
        >
          <template slot="prefix"> Selected Branch </template>
          <el-option
            v-for="item in operatorBranches"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </DadsFilterSelect>
      </el-form>
      <el-tooltip
        placement="bottom"
        :content="
          softphoneEnabled
            ? 'Softphone Enabled'
            : softphoneLocked
            ? 'Network Connection Lost'
            : 'Softphone Disabled'
        "
        v-if="userHasExtension && !mobileDevice"
      >
        <el-button
          id="devices-dropdown-toolbar"
          size="mini"
          @click="toggleSoftphoneEnabled"
          :disabled="softphoneLocked"
          style="box-shadow: none"
        >
          <v-svg
            :class="
              softphoneEnabled
                ? 'voxo-green'
                : softphoneLocked
                ? 'voxo-dark-red'
                : 'icon-muted'
            "
            sprite="headset"
          />
        </el-button>
      </el-tooltip>
      <el-popover
        placement="bottom"
        trigger="click"
        v-show="softphoneEnabled"
        @show="queryAudioDevices"
        popper-class="devicePopper"
      >
        <div class="dropdown-icon" slot="reference">
          <v-svg sprite="chevron-down"></v-svg>
        </div>
        <el-form class="form-modal">
          <el-select
            v-model="selectedAudioDevice"
            v-if="inputDevices.length"
            v-loading="devicesLoading"
            placeholder="Select Audio Device"
            @change="changeAudioInput"
          >
            <template slot="prefix">Audio Device</template>
            <el-option
              v-for="(item, index) in inputDevices"
              :key="index"
              :value="item.deviceId"
              :label="item.label"
            />
          </el-select>
        </el-form>
      </el-popover>

      <!--        TOOLBAR COMPONENT FOR MANAGER QUEUE DASH-->
      <div
        class="toolbar-form flex"
        v-if="queueManagerDashboard"
        style="width: 100%"
        :style="softphoneEnabled ? 'margin-left: -18.5px;' : ''"
      >
        <DadsFilterSelect
          v-model="selectedQueueLayout"
          value-key="id"
          placeholder="Select layout"
          class="ml-10"
          style="border-bottom-right-radius: 0; border-top-right-radius: 0"
          @change="() => queueDashboardEvent('loadDashboard')"
        >
          <template slot="prefix"> Layout </template>
          <el-option
            v-for="item in userQueueLayouts"
            :key="item.id"
            :value="item"
            :label="item.name"
          />
        </DadsFilterSelect>

        <el-dropdown trigger="click" @command="onLayoutCommand">
          <div>
            <el-button
              style="
                height: 45px;
                border-bottom-left-radius: 0;
                border-top-left-radius: 0;
              "
            >
              <i class="el-icon-setting voxo-blue" />
            </el-button>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-if="selectedQueueLayout"
              command="loadEditLayoutForm"
            >
              Edit layout
            </el-dropdown-item>
            <el-dropdown-item command="removeLayout">
              Remove layout
            </el-dropdown-item>
            <el-dropdown-item command="loadCreateLayoutForm">
              Create layout
            </el-dropdown-item>
            <el-dropdown-item
              v-if="selectedQueueLayout"
              command="duplicateLayout"
            >
              Duplicate layout
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown
          v-if="selectedQueueLayout"
          style="margin-left: auto"
          trigger="click"
          @command="onAddWidgetCommand"
        >
          <div>
            <el-button style="height: 45px"> Add Widget </el-button>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in widgetOptions"
              :key="index"
              :command="item.command"
            >
              <v-svg :sprite="item.sprite" :class="item.color" />
              {{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="box-right flex align-center pl-10">
      <el-tooltip
        :content="getTooltipStatus()"
        placement="bottom"
        v-if="queueServiceOptions"
      >
        <el-dropdown trigger="click">
          <el-button class="agent-status-indicator">
            <status-indicator :status="agentStatus"> </status-indicator>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <span
                class="pr-10"
                style="min-width: 75px; display: inline-block"
                >{{ queueLoggedIn ? "Logged In" : "Logged Out" }}</span
              >
              <el-switch
                :value="queueLoggedIn"
                @change="toggleQueueLoggedIn"
                active-color="#46CA63"
              >
              </el-switch>
            </el-dropdown-item>
            <el-dropdown-item v-if="queueLoggedIn">
              <div>
                <el-radio-group
                  v-model="selectedPauseReason"
                  @change="handlePauseReasonChange"
                >
                  <el-radio
                    class="black-text mt-10"
                    v-for="(item, index) in pauseReasons"
                    :key="index"
                    :label="item"
                    style="display: block; margin-left: 0"
                  />
                </el-radio-group>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-tooltip>

      <el-dropdown
        class="toolbar-avatar"
        trigger="click"
        @command="onCommand"
        :hide-on-click="false"
        ref="avatarDropdown"
      >
        <div class="avatar-group">
          <div class="contact-avatar" v-if="userHasAvatar">
            <img :src="userHasAvatar" />
          </div>
          <div class="contact-avatar" v-else-if="userHasExtension">
            {{ user.myExtension.name.substring(0, 1).toUpperCase() }}
          </div>
          <div
            class="contact-avatar"
            v-else-if="!userHasExtension && !userHasAvatar"
          >
            V
          </div>
          <div class="dnd-icon" v-if="userDND">
            <hr />
            <status-indicator></status-indicator>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="/profile">Settings</el-dropdown-item>
          <el-dropdown-item v-if="userHasQueues && !globalQueueActions">
            <div @click="queueModal">
              <span> Manage Queues </span>
            </div>
          </el-dropdown-item>
          <el-tooltip
            v-if="userHasExtension"
            :content="userDND ? 'On' : 'Off'"
            placement="left"
          >
            <el-dropdown-item command="dnd">
              <span class="pr-10">DND</span>
              <el-switch
                :value="userDND"
                @change="toggleUserDND"
                active-color="#ff8f02"
              >
              </el-switch>
            </el-dropdown-item>
          </el-tooltip>

          <el-dropdown-item v-if="whatsNewURL">
            <div @click="openWhatsNew">
              <span>
                <status-indicator
                  status="negative"
                  :style="whatsNewBadge"
                  id="whatsNewBadge"
                >
                </status-indicator>

                What's New
              </span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="toggleHotKeys">
              <span> Hot Keys </span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="toggleNetworkTest">
              <span> Test Network </span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item v-if="isSuperAdmin">
            <div @click="toggleDadTap">
              <span> SIP On Tap </span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item v-if="!whiteLabel">
            <div @click="toggleIntercom">
              <span> Get Help </span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item command="/logout">Logout</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <button
        @click="toggleSidebar"
        v-if="menuBurger === 'right'"
        class="toggle-sidebar toggle-sidebar__right card-base card-shadow--small"
      >
        <i class="el-icon-menu"></i>
      </button>
    </div>

    <el-dialog
      class="form-modal"
      :visible.sync="pauseReasonVisible"
      :close-on-press-escape="false"
      :show-close="false"
      :close-on-click-modal="false"
      :modal="false"
    >
      <el-form>
        <h2 class="form-section-header">Agent Pause Reason</h2>
        <el-input
          type="text"
          v-model="otherPauseReason"
          placeholder="Enter Other"
          v-if="pauseReason === 'Other'"
        >
          <template class="label-prefix" slot="prefix">Other Reason</template>
        </el-input>
      </el-form>
      <div class="inline-form-group justify-flex-end">
        <el-button @click.prevent="processPause"> Submit </el-button>
        <el-button @click.prevent="cancelPause"> Cancel </el-button>
      </div>
    </el-dialog>

    <el-dialog
      width="30%"
      :visible.sync="hotKeysVisible"
      :show-close="true"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
      :modal="true"
    >
      <MacHotKeys v-if="osVersion === 'Mac'"></MacHotKeys>
      <WinHotKeys v-else></WinHotKeys>
    </el-dialog>

    <queues-modal
      v-if="!globalQueueActions"
      :visible="queueModalVisible"
      @modalClosed="queueModalVisible = false"
    />

    <el-dialog
      :visible="wireTapVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleCloseWireTapModal"
      :modal="false"
    >
      <h2 class="form-section-header black-text">Welcome, Father</h2>
      <p class="black-text">
        This feature that allows you to view a live packet capture of SIP
        traffic.
      </p>
      <p class="black-text">
        You are about to be redirected to a live packet capture of our SIP
        Activity. This session will die after 30 minutes. All of the keybindings
        can be found
        <a
          href="https://github.com/irontec/sngrep/wiki/Configuration#keybindings"
          target="_blank"
          >here.</a
        >
      </p>
      <p class="black-text">
        Also, if you'd like to save pcap(s) and have them emailed automatically,
        set the filename to an email address. Enjoy your journey.
      </p>
      <el-button @click="startWireTap"> Pour Now </el-button>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { debounce } from "lodash";
import feathersClient, { apiV2Host } from "../feathers/feathers-client";
import { globalEventBus } from "@/globalEventBus";
import extensionStatus from "../ref/extension-status";
import {isMobileDevice, isWhiteLabel} from "@/globals/globals";
import MacHotKeys from "../views/pages/users/components/hot-keys-mac";
import WinHotKeys from "../views/pages/users/components/hot-keys-win";
import DadsFilterSelect from "@/components/select";
import QueuesModal from "../views/hudportal/queue-management/components/manage-queues";

export default {
  name: "Toolbar",
  props: ["menuBurger"],
  components: {
    MacHotKeys,
    WinHotKeys,
    DadsFilterSelect,
    QueuesModal,
  },
  data() {
    return {
      popoverWidth: 300,
      fullscreen: false,
      lang: "us",
      pauseReasonVisible: false,
      pauseReasons: [
        "Available",
        "Account Review",
        "Break",
        "Lunch",
        "Meeting",
        "Personal",
        "Other",
      ],
      pauseReason: "",
      otherPauseReason: "",
      activeOperatorBranches: [],
      inputDevices: [],
      devicesLoading: false,
      selectedAudioDevice: "",
      hotKeysVisible: false,
      modKeyActive: false,
      queueModalVisible: false,
      wireTapVisible: false,
      selectedPauseReason: "Available",
      skipPause: false,
      enableIntercom: true,
      tenantsLoading: false,

      widgetOptions: [
        {
          name: "Abandoned",
          command: "abandonedCalls",
          sprite: "call-inbound",
          color: "voxo-red",
        },
        {
          name: "Active calls",
          command: "activeCalls",
          sprite: "receptionist",
          color: "voxo-blue",
        },
        {
          name: "Active calls list",
          command: "activeCallList",
          sprite: "queue",
          color: "voxo-green",
        },
        {
          name: "Agents By Queue",
          command: "agentTable",
          sprite: "user",
          color: "voxo-blue",
        },
        {
          name: "Agent Totals",
          command: "agentTableAggregated",
          sprite: "user",
          color: "voxo-pink",
        },
        {
          name: "Agent outbound",
          command: "outboundCalls",
          sprite: "call-outbound",
          color: "voxo-purple",
        },
        {
          name: "Avg answer time",
          command: "avgAnswerTime",
          sprite: "clock",
          color: "voxo-green",
        },
        {
          name: "Complete callbacks",
          command: "completedCallbacks",
          sprite: "call-outbound",
          color: "voxo-aqua",
        },
        {
          name: "Exits",
          command: "exitStats",
          sprite: "exit",
          color: "voxo-orange",
        },
        {
          name: "Inbound answered",
          command: "inboundAnswered",
          sprite: "call-inbound",
          color: "voxo-green",
        },
        {
          name: "Queued callbacks",
          command: "queuedCallbacks",
          sprite: "refresh",
          color: "voxo-orange",
        },
        {
          name: "Queues",
          command: "queuesTable",
          sprite: "queue",
          color: "voxo-red",
        },
        {
          name: "Total inbound",
          command: "totalInbound",
          sprite: "call-inbound",
          color: "voxo-blue",
        },
        {
          name: "Transfers",
          command: "transferredCalls",
          sprite: "transfer",
          color: "voxo-orange",
        },
        {
          name: "Waiting calls",
          command: "waitingCalls",
          sprite: "call-inbound",
          color: "voxo-yellow",
        },
        {
          name: "Waiting calls list",
          command: "waitingCallList",
          sprite: "clock",
          color: "voxo-yellow",
        },
      ],

      selectedTenantPopulated: false,
      tenantsQuery: null,
    };
  },
  computed: {
    user() {
      console.log("something about the user changed");
      return this.$store.state.auth.user;
    },
    userHasExtension() {
      if (this.user) {
        return this.user.hasOwnProperty("myExtension");
      }
      return false;
    },
    userHasAvatar() {
      if (this.user) {
        return this.user.avatarPath;
      }
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    tenantsList() {
      if (this.user) {
        return this.$store.state.authTenants;
      }
      return [];
    },
    selectedQueue() {
      return this.$store.state.selectedQueue;
    },
    queueList() {
      return this.$store.state.queueList;
    },
    hudMode() {
      return this.$store.state.hudMode;
    },
    queueMode() {
      return this.$store.state.queueMode;
    },
    operatorMode() {
      return this.$store.state.operatorMode;
    },
    operatorBranches() {
      return this.$store.state.operatorBranches;
    },
    checkedOperatorBranches() {
      return this.$store.state.activeOperatorBranches;
    },
    selectedOperatorBranch() {
      return this.$store.state.activeOperatorBranch;
    },
    dropdownVisible() {
      if (!this.user) {
        return false;
      }
      if (+this.user.userRole === 5 || +this.user.userRole ===  13 || +this.user.userRole === 14) {
        return false;
      }
      return !this.hudMode;
    },
    queueLoggedIn() {
      return this.$store.state.queueLoggedIn;
    },
    userHasQueues() {
      if (this.user) {
        if (this.user.hasOwnProperty("myExtension")) {
          return !!this.user.myExtension.queueIds.length;
        }
      }
      return false;
    },
    queuePaused() {
      return this.$store.state.queuePaused;
    },
    userDND() {
      return this.$store.state.userDND;
    },
    userHostServer() {
      return this.$store.state.userHostServer;
    },
    queuePausedReason() {
      return this.$store.state.queuePausedReason;
    },
    activeQueue() {
      if (this.user.hasOwnProperty("myExtension")) {
        return (
          this.$store.state.activeQueue &&
          this.user.myExtension.tenantId === this.selectedTenant.id
        );
      }
      return false;
    },
    queueServiceOptions() {
      if (this.user) {
        if (this.user.hasOwnProperty("myExtension")) {
          return (
            this.queueMode &&
            this.activeQueue &&
            this.user.myExtension.queueIds.includes(this.selectedQueue.id)
          );
        }
      }
      return false;
    },
    agentStatus() {
      if (this.queueLoggedIn && this.queuePaused) {
        return "intermediary";
      }
      if (this.queueLoggedIn) {
        return "positive";
      }
      return "negative";
    },
    softphoneEnabled() {
      return this.$store.state.softphoneEnabled;
    },
    audioInputDevice() {
      const fromStore = this.$store.state.audioInputDeviceId;
      const fromList = this.inputDevices;

      if (fromList.length) {
        if (!fromStore) {
          this.$store.commit("setAudioInputDeviceId", fromList[0].deviceId);
        }

        let foundMatch = false;
        if (fromStore) {
          for (let i = 0; i < fromList.length; i++) {
            if (fromList[i].deviceId === fromStore) {
              foundMatch = true;
              break;
            }
          }
          if (foundMatch) {
            this.selectedAudioDevice = fromStore;
            return fromStore;
          }
        } else {
          this.selectedAudioDevice = fromList[0].deviceId;
          return fromList[0].deviceId;
        }

        this.selectedAudioDevice = foundMatch
          ? fromStore
          : fromList[0].deviceId;
        return foundMatch ? fromStore : fromList[0].deviceId;
      }
      return null;
    },
    osVersion() {
      const isMac = navigator.appVersion.indexOf("Mac") !== -1;
      return isMac ? "Mac" : "Win";
    },
    userIsAdmin() {
      if (this.user) {
        const adminRoles = [1, 3, 11, 12];
        return adminRoles.includes(this.user.userRole);
      }
    },
    isSuperAdmin() {
      if (this.user) {
        return +this.user.userRole === 1;
      }
    },
    mobileDevice() {
      return isMobileDevice();
    },
    whiteLabel() {
      return isWhiteLabel();
    },
    softphoneLocked() {
      return this.$store.state.softphoneLocked;
    },

    whatsNewBadge() {
      return this.$store.state.whatsNewBadge;
    },

    whatsNewURL() {
      const branding = { ...this.$store.state.branding };
      const { changelogURL } = branding;
      return changelogURL ? changelogURL : null;
    },

    userQueueLayouts() {
      return this.$store.state.userQueueLayouts;
    },

    selectedQueueLayout: {
      get: function () {
        return this.$store.state.selectedQueueLayout;
      },
      set: function (val) {
        this.$store.commit("setSelectedQueueLayout", val);
      },
    },

    queueManagerDashboard() {
      return this.$route.path === "/omnia/queue-dashboard";
    },

    globalQueueActions() {
      if (this.selectedTenant) {
        return !!this.selectedTenant.globalQueueActions;
      }
      return false;
    },
  },
  watch: {
    checkedOperatorBranches() {
      this.activeOperatorBranches = this.checkedOperatorBranches;
    },
    queuePausedReason() {
      // this.skipPause = true;

      if (!(this.queuePausedReason && this.queuePaused)) {
        this.selectedPauseReason = "Available";
        return;
      }

      if (!this.pauseReasons.includes(this.queuePausedReason)) {
        this.selectedPauseReason = "Other";
        return;
      }

      this.selectedPauseReason = this.queuePausedReason;
    },
    user() {
      if (this.user) {
        this.queryTenantsList();
      }
    },

    tenantsQuery: debounce(function () {
      this.queryTenantsList();
    }, 175),
  },
  methods: {
    onCommand(path) {
      if (path !== "dnd") {
        this.$router.push(path);
        this.$refs.avatarDropdown.visible = false;
      }
    },
    onLayoutCommand(command) {
      this.queueDashboardEvent(command);
    },
    onAddWidgetCommand(command) {
      this.queueDashboardEvent(command);
    },
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    },
    resizePopoverWidth() {
      if (window.innerWidth <= 768) {
        this.popoverWidth = 250;
      } else {
        this.popoverWidth = 300;
      }
    },
    onChangeTenant(val) {
      // Switch immediately; refresh full detail (timezone, etc.) in the
      // background so the UI doesn't block on the slow tenant fetch.
      this.$store.commit("setSelectedTenant", val);

      const token = this.$store.state.auth.accessToken;
      axios
        .get(`${apiV2Host}/admin/tenants/${val.id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((freshTenant) => {
          if (freshTenant.data) {
            // Merge (don't replace) so watchers don't re-fire and flicker.
            this.$store.commit("patchSelectedTenant", freshTenant.data);
          }
        })
        .catch((e) => console.log("failed to fetch tenant data", e));
    },
    changeQueue(val) {
      this.$store.commit("setSelectedQueue", val);
    },
    toggleQueueLoggedIn(val) {
      if (this.$store.state.queueLoggedIn && this.$store.state.queuePaused) {
        this.toggleQueuePaused(0);
      }
      this.$store.commit("setQueueLoggedIn", val);
      globalEventBus.$emit("queueLoginToggled", val);
    },
    toggleQueuePaused(val) {
      this.$store.commit("setQueuePaused", val);
      let pauseReason = this.pauseReason;
      if (!pauseReason.length || pauseReason === "Other") {
        pauseReason = this.otherPauseReason;
      }

      if (!pauseReason.length && val) {
        this.$notify({
          title: "Warning",
          message: "You Must Include A Pause Reason!",
          type: "warning",
        });
      } else {
        this.$store.commit("setQueuePausedReason", pauseReason);
        globalEventBus.$emit("queuePauseToggled", { value: val, pauseReason });
        this.pauseReasonVisible = false;
      }
    },
    handlePauseReasonChange() {
      if (this.selectedPauseReason === "Available") {
        this.pauseReason = "";
        this.toggleQueuePaused(false);
        return;
      }

      //pop other modal
      if (this.selectedPauseReason === "Other") {
        this.pauseReason = "Other";
        this.handleQueuePause(true);
        return;
      }

      //apply standard pause reason
      this.pauseReason = this.selectedPauseReason;
      this.toggleQueuePaused(true);
    },
    toggleUserDND(val) {
      this.$store.commit("setUserDND", val);
      //send the action to ami, userevent ami. this should result in an event firing the assures the store is accurate.
      const dndStatus = val === true ? "on" : "";
      const { peerName } = this.user.myExtension;
      feathersClient.service("nats-actions-handler").create({
        reqType: "setDND",
        peerName,
        dndStatus,
        hostServer: this.userHostServer,
        extensionId: this.user.myExtension.id,
      });

      // ⭐️ `ENABLE/DISABLE DND` user event log ⭐️ //
      if (val) {
        this.$store.dispatch("userEvents/create", { event: "Enable DND" });
      } else {
        this.$store.dispatch("userEvents/create", { event: "Disabled DND" });
      }
    },
    toggleSoftphone(val) {
      this.$store.commit("setSoftphoneVisibility", val);
    },
    toggleSoftphoneEnabled() {
      const value = !this.softphoneEnabled;
      this.$store.commit("setSoftphoneEnabled", value);
      if (value) {
        this.queryAudioDevices();

        // ⭐️ `ENABLE SOFTPHONE` user event log ⭐️ //

        this.$store.dispatch("userEvents/create", {
          event: "Enabled Softphone",
        });
      } else {
        // ⭐️ `DISABLE SOFTPHONE` user event log ⭐️ //
        this.$store.dispatch("userEvents/create", {
          event: "Disabled Softphone",
        });
      }
    },
    incomingCallStatus(val) {
      this.$store.commit("setIncomingCallStatus", val);
    },
    handleQueuePause(val) {
      if (val) {
        this.pauseReasonVisible = true;
      } else {
        this.toggleQueuePaused(false);
      }
    },
    processPause() {
      this.toggleQueuePaused(true);
      this.pauseReason = "";
      this.otherPauseReason = "";
    },
    cancelPause() {
      this.pauseReasonVisible = false;
      this.pauseReason = "";
      this.otherPauseReason = "";
    },
    getTooltipStatus() {
      if (this.queuePaused) {
        return `Paused for ${this.queuePausedReason} ${this.selectedQueue.name}`;
      }
      if (this.queueLoggedIn) {
        return `Logged in ${this.selectedQueue.name}`;
      }
      return `Logged out ${this.selectedQueue.name}`;
    },
    getStatusFromEvent(code) {
      return extensionStatus(code);
    },
    changeAudioInput(val) {
      this.$store.commit("setAudioInputDeviceId", val);
    },
    async queryAudioDevices() {
      if (this.mobileDevice) return;

      this.devicesLoading = true;

      try {
        await navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            stream.getTracks().forEach((track) => track.stop());
          });
      } catch (e) {
        console.log("audio permissions blocked");
        this.$notify({
          title: "Warning",
          message: "No Audio Devices Found. Permission is blocked",
          type: "warning",
        });
        this.$store.commit("setSoftphoneEnabled", false);
        return;
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then((data) => {
          //gather appropriate input devices
          this.inputDevices = data.filter((item) => item.kind === "audioinput");

          //if no input devices notify and disable softphone
          if (!this.inputDevices.length) {
            this.$notify({
              title: "Warning",
              message: "No Audio Devices Found. Softphone Is Disabled",
              type: "warning",
            });
            this.$store.commit("setSoftphoneEnabled", false);
            return;
          }

          //devices were reloaded, make sure the device in the store exists/makes sense
          const fromStore = this.audioInputDevice;
          let foundMatch = false;
          for (let i = 0; i < this.inputDevices.length; i++) {
            if (fromStore === this.inputDevices[i].deviceId) {
              foundMatch = true;
              break;
            }
          }

          if (!foundMatch && this.inputDevices.length) {
            console.log("current device is no longer there. set a default");
            this.$store.commit(
              "setAudioInputDeviceId",
              this.inputDevices[0].deviceId
            );
          }

          this.devicesLoading = false;
        })
        .catch((e) => {
          this.$notify({
            title: "Warning",
            message: "No Audio Devices Found. Softphone Is Disabled",
            type: "warning",
          });
          this.$store.commit("setSoftphoneEnabled", false);
        });
    },
    toggleHotKeys() {
      this.hotKeysVisible = true;
      this.$refs.avatarDropdown.visible = false;
    },
    closeHotKeys() {
      this.hotKeysVisible = false;
    },
    toggleNetworkTest() {
      this.$store.commit("setNetworkTestVisible", true);
      this.$refs.avatarDropdown.visible = false;
    },
    openWhatsNew() {
      this.$store.commit("whatsNewBadge", "display:none;");
      let whatsNewBadgeDiv = document.getElementById("whatsNewBadge");
      whatsNewBadgeDiv.style = "display:none;";
      window.open(this.whatsNewURL);
    },
    toggleIntercom() {
      this.enableIntercom = !this.enableIntercom;
      this.enableIntercom ? this.hideIntercom() : this.showIntercom();
    },
    hideIntercom() {
      window.Intercom("hide");
    },
    showIntercom() {
      window.Intercom("show");
    },
    toggleDadTap() {
      this.wireTapVisible = true;
    },
    setActiveOperatorBranch(val) {
      this.$store.commit("setOperatorActiveBranch", val);
    },
    servicesQueue(id) {
      if (this.user) {
        if (this.user.hasOwnProperty("myExtension")) {
          return this.user.myExtension.queueIds.includes(id);
        }
      }
    },
    queueModal() {
      this.queueModalVisible = true;
    },
    handleCloseWireTapModal() {
      this.wireTapVisible = false;
    },
    startWireTap() {
      feathersClient
        .service("nats-actions-handler")
        .create({
          reqType: "startWireTap",
          expression: "",
        })
        .then((res) => {
          if (res === "Request Failed") {
            this.$message({
              message: "Something went wrong! Try again.",
              duration: 1000,
            });
          } else {
            const link = document.createElement("a");
            link.href = res.url;
            link.target = "_blank";
            link.click();
            link.remove();
            this.handleCloseWireTapModal();
          }
        })
        .catch(() => {
          this.$message({
            message: "Something went wrong! Try again.",
            duration: 1000,
          });
          this.$message("Something went wrong! Try again.");
        });
    },
    queueDashboardEvent(event) {
      globalEventBus.$emit("queueManagerDashboardEvent", { event });
    },

    remoteSearchTenants(query) {
      this.tenantsQuery = query;
    },

    async queryTenantsList() {
      const token = this.$store.state.auth.accessToken;
      this.tenantsLoading = true;

      try {
        let url = `${apiV2Host}/admin/tenants`;

        if (this.tenantsQuery) {
          url = `${url}?query=${this.tenantsQuery}`;
        }

        const res = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const { records } = res.data;
        const { selectedTenant } = JSON.parse(localStorage.getItem("vuex"));

        // Only fetch fresh tenant data if not searching (to ensure timezone is populated)
        if (selectedTenant && selectedTenant.id && !this.tenantsQuery) {
          try {
            const freshTenant = await axios.get(`${apiV2Host}/admin/tenants/${selectedTenant.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });

            if(freshTenant.data){
              // Check if tenant is in records, if not add it
              const searchTenant = records.find((item) => item.id === selectedTenant.id);
              if (!searchTenant) {
                records.push(freshTenant.data);
              }
              this.$store.commit("setSelectedTenant", freshTenant.data);
              this.selectedTenantPopulated = true;
            }
          } catch(e) {
            console.log("selected tenant from store not found");
            // Fallback to first tenant if fetch fails
            if (records.length > 0) {
              this.$store.commit("setSelectedTenant", records[0]);
            }
          }
        } else if (records.length > 0 && !this.selectedTenantPopulated) {
          // No selected tenant in storage, use first one
          this.$store.commit("setSelectedTenant", records[0]);
        }

        this.$store.commit("setTenants", records);
        this.tenantsLoading = false;
      } catch (err) {
        this.tenantsLoading = false;
      }
    },
  },
  mounted() {
    this.resizePopoverWidth();

    if(this.user){
      this.queryTenantsList();
    }

    window.addEventListener("resize", this.resizePopoverWidth);
    window.Intercom("onHide", () => {
      this.enableIntercom = true;
    });

    //devices for webrtc
    this.queryAudioDevices();

    window.addEventListener("keydown", (e) => {
      if (e.key === "Alt") {
        e.preventDefault();
        this.modKeyActive = true;
      }
      if (this.modKeyActive && e.code === "KeyK") {
        e.preventDefault();
        this.hotKeysVisible ? this.closeHotKeys() : this.toggleHotKeys();
      }
    });
    window.addEventListener("keyup", (e) => {
      if (e.key === "Alt") {
        this.modKeyActive = false;
      }
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizePopoverWidth);
  },
};
</script>

<style lang="scss">
@import "../assets/scss/_variables";
@import "../assets/scss/_mixins";

.toolbar {
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  .username {
    margin-left: 20px;
    font-weight: bold;
    cursor: pointer;
    @include text-bordered-shadow();
  }

  .avatar {
    border-radius: 50%;
    width: 35px;
    height: 35px;
    border: 1px solid #fff;
    margin-left: 20px;
    box-sizing: border-box;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.5s;

    &:hover {
      box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08),
        0px 2px 7px 0 rgba(0, 0, 0, 0.08);
    }
  }

  .notification-icon {
    font-size: 20px;
    outline: none;
    padding: 0;
    background: transparent;
    border: none;
    margin-left: 20px;
    //color: #aab7c5;
    color: transparentize($text-color, 0.7);
    @include text-bordered-shadow();

    &:hover {
      color: $text-color-accent;
    }
  }

  .toggle-sidebar {
    border: 1px solid transparent;
    height: 36px;
    min-height: 36px;
    line-height: 36px;
    width: 36px;
    min-width: 36px;
    max-width: 36px;
    box-sizing: border-box;
    text-align: center;
    margin: 0;
    outline: none;
    margin-right: 10px;
    font-size: 24px;
    padding: 0;
    cursor: pointer;
    display: inline-block;
    color: $text-color;
    background: white;
    display: none;
    opacity: 0;
    transition: all 0.2s;

    &__right {
      margin-right: 0px;
      margin-left: 5px;
    }

    &:hover,
    &:focus,
    &:active {
      color: $text-color-accent;
      border-color: $text-color-accent;
    }
  }

  .fullscreen-button {
    font-size: 24px;
    cursor: pointer;
    outline: none;
    padding: 0;
    background: transparent;
    border: none;
    margin-left: 20px;
    //color: #aab7c5;
    color: transparentize($text-color, 0.7);
    @include text-bordered-shadow();

    &:hover {
      color: $text-color-accent;
    }
  }

  .el-dropdown {
    .flag-icon {
      box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.08);
      cursor: pointer;
      border: 1px solid lighten($background-color, 20%);
      background-color: lighten($background-color, 20%);
    }
  }

  .toolbar-select {
    .el-input__inner {
      background: $background-color !important;
    }
  }
}

.el-switch {
  padding-left: 0;
}

.el-form {
  margin-top: 0;
}

.form-section-header {
  margin-top: 0;
}

.el-dropdown-menu__item--divided::before {
  display: none;
}

.agent-status-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 9px 10px;
  margin-top: 2px;
  .status-indicator {
    margin-right: 5px;
  }
}

.status-light {
  bottom: 0px;
  right: -3px;
}

.status-indicator {
  width: 15px;
  height: 15px;
}

.devicePopper {
  width: 300px;
  padding: 0 10px;
}

@media (max-width: 650px) {
  .toolbar {
    .username {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .toolbar {
    padding: 0 10px;

    .toggle-sidebar {
      display: block;
      opacity: 1;
    }

    .fullscreen-button {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.contact-avatar {
  width: 30px;
  height: 30px;
  margin-left: 20px;
}
.form-modal {
  .el-select {
    margin: 0;
  }
}

.queue-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
